<div id="add-additional-fields" [ngSwitch]="editMode">
  <ng-template [ngSwitchCase]="true">
    <app-form-master [form]="form" (submitForm)="saveAdditionalFields()">
      <div class="add-additional-fields-form">
        <div
          class="form-row"
          *ngFor="let additionalField of additionalFields; let pos = index"
        >
          <app-input-field
            [label]="additionalField.key"
            fieldId="{{ pos }}_additional_field"
            [placeholder]="'PLACEHOLDER.ENTER_VALUE' | translate"
            [fieldControl]="form.get(getFormKeyForField(pos))"
            [maxlength]="1000"
          >
          </app-input-field>
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="form-action save-action">
          {{ 'ACTION.SAVE' | translate }}
        </button>
      </div>
    </app-form-master>
  </ng-template>

  <ng-template ngSwitchDefault>
    <div
      [ngSwitch]="hasValue"
      class="additional-fields-wrapper"
      (click)="toggleForm(true)"
    >
      <ol *ngSwitchCase="true" class="additional-field-list">
        <ng-container *ngFor="let additionalField of additionalFields">
          <li *ngIf="additionalField.value" class="additional-field">
            <strong class="field-name">
              {{ additionalField.key }}
            </strong>

            <span class="field-value">
              {{ additionalField.value }}
            </span>
          </li>
        </ng-container>
      </ol>

      <button type="button" class="primary-action" *ngSwitchDefault>
        {{ 'ACTION.ADD_FIELD' | translate }}
      </button>
    </div>
  </ng-template>
</div>
